import React, {useEffect, useState} from "react";
import {LatexEditor} from "../LatexEditor";
import {useFormContext} from "react-hook-form";
import {QuestionTypes} from "../../../static/enums/Questions";

export interface InputTextAnswerProps {
    prefix: string;
    height?: string;
    displayTitle: string;
    editorTitle: string;
}

export default function InputTextAnswer({ displayTitle, prefix, editorTitle, height }: InputTextAnswerProps) {
    const { formState, setValue, resetField } = useFormContext<any>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (formState.dirtyFields[`${prefix}class`]) {
            setValue(`${prefix}correct_answer`, null)
            setValue(`${prefix}answer_config`, null)
            resetField(`${prefix}class`, {
                keepDirty: true,
                defaultValue: QuestionTypes.input_text
            })
        }
        setLoading(false);
    }, [])

    return (
        loading
        ? null
        : (
            <LatexEditor
                controllerName={`${prefix}correct_answer`}
                editorTitle={editorTitle}
                displayTitle={displayTitle}
                height={height}
            />
        )
    )
}